import React from 'react';

export const Progress = (props) => {
  const {
    completed = false,
    text = 'step name',
    displayStatusLine = true
  } = props;

  const colorClass = completed ? 'text-primary' : 'text-gray-lighten-2';
  const backgroundColor = completed ? 'bg-primary' : 'bg-gray-lighten-2';

  return (
    <div className={`d-flex align-items-center ${colorClass} small mx-1 text-nowrap`} style={displayStatusLine ? {width: 'inherit'} : null}>
      <i className='fa fa-check-circle fa-2x mx-1' aria-hidden="true"></i>
      {text}
      {displayStatusLine && <svg className={`${backgroundColor} ml-2 w-100`} height={2}>
        <rect y={2}/>
      </svg>}
    </div>
  );
};

export const MobileProgressBar = (props) => {
  const {
    progresses = [],
    completedIndex = -1,
  } = props;
  return (
    <ol className="progressbar p-0">
      {progresses.map((item, index) => {
        const isComplete = (index <= completedIndex) ? 'is-complete' : '';
        return (
          <li key={`${index}-${isComplete}`} className={`progressbar-step ${isComplete}`}>
            <svg className="progressbar-icon">
              <use href="#checkmark-bold"/>
            </svg>
          </li>
        );
      })}
    </ol>
  );
};



// WEBPACK FOOTER //
// ./src/Account/Order/Progress.js